// extracted by mini-css-extract-plugin
export var start_sect = "steps_section-module--start_sect--81HA7";
export var start_sect_header = "steps_section-module--start_sect_header--11SsG";